// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__1L-Zp","open":"MenuToggle_open__2OCEZ"};